var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickCircleFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99959 2.16846C5.40793 2.16846 1.66626 5.91012 1.66626 10.5018C1.66626 15.0935 5.40793 18.8351 9.99959 18.8351C14.5913 18.8351 18.3329 15.0935 18.3329 10.5018C18.3329 5.91012 14.5913 2.16846 9.99959 2.16846ZM13.9829 8.58512L9.25793 13.3101C9.14126 13.4268 8.98293 13.4935 8.81626 13.4935C8.64959 13.4935 8.49126 13.4268 8.37459 13.3101L6.01626 10.9518C5.77459 10.7101 5.77459 10.3101 6.01626 10.0685C6.25793 9.82679 6.65793 9.82679 6.89959 10.0685L8.81626 11.9851L13.0996 7.70179C13.3413 7.46012 13.7413 7.46012 13.9829 7.70179C14.2246 7.94346 14.2246 8.33512 13.9829 8.58512Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleFilled);
export default __webpack_public_path__ + "static/media/tick-circle-filled.c7ad6fc948aacbaab30653d3eff6c334.svg";
export { ForwardRef as ReactComponent };